import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
  {
    id: 'info-we-collect',
    heading: '1. Information We Collect',
    body: [
      'We collect the minimum amount of personal data necessary to provide and maintain the Service.',
    ],
    subsections: [
      {
        heading: 'Information You Provide',
        list: [
          { label: 'Email Address', text: 'Required for account creation and authentication.' },
          { label: 'Name', text: 'Collected if voluntarily provided by the user.' },
          { label: 'Billing Details', text: 'Processed via our third-party payment processors for subscription management.' },
          { label: 'Support Communications', text: 'Records of your requests for assistance.' },
        ],
      },
      {
        heading: 'Automatically Collected Information',
        list: [
          { label: 'Technical Data', text: 'IP address, device type, browser type, and operating system.' },
          { label: 'Usage Data', text: 'Usage logs and analytics to improve performance, reliability, and security.' },
          { label: 'Cookies', text: 'We use essential cookies for service functionality and security.' },
        ],
      },
    ],
  },
  {
    id: 'how-we-use',
    heading: '2. How We Use Your Information',
    body: ['We use your personal data to:'],
    list: [
      'Maintain the Service and respond to support requests.',
      'Authenticate accounts and process subscriptions.',
      'Prevent fraud, abuse, and security threats.',
      'Improve the performance of our AI-driven tools.',
      'Comply with our legal and regulatory obligations.',
    ],
    subsections: [
      {
        body: ['Note: We do not sell your personal data.'],
      },
    ],
  },
  {
    id: 'data-storage',
    heading: '3. Data Storage and International Transfers',
    list: [
      { label: 'Hosting', text: 'Our primary servers are located in Malaysia.' },
      { label: 'International Processing', text: 'While data is stored in Malaysia, it may be processed internationally where necessary for essential infrastructure support or payment processing.' },
      { label: 'Retention', text: 'We retain personal data only as long as necessary to provide the Service. When an account is deleted, account data is scheduled for permanent deletion within 90 days.' },
    ],
  },
  {
    id: 'data-security',
    heading: '4. Data Security',
    body: ['We implement robust technical and organizational safeguards to protect your data, including:'],
    list: [
      { label: 'TLS-Secured Transmission', text: 'Protecting data during transit.' },
      { label: 'Access Controls', text: 'Limiting data access to authorized personnel only.' },
      { label: 'Continuous Monitoring', text: 'Ongoing security checks to prevent and detect unauthorized access.' },
    ],
  },
  {
    id: 'your-rights',
    heading: '5. Your Rights',
    body: ['Depending on your location, you may have the following rights regarding your personal data:'],
    list: [
      'The right to access, correct, or request deletion of your data.',
      'The right to object to or restrict certain processing activities.',
      'The right to data portability or to withdraw consent.',
    ],
  },
  {
    id: 'age',
    heading: '6. Age Restriction',
    body: [
      'Aina Suite is intended for individuals aged 18 years or older. We do not knowingly collect personal data from individuals under 18.',
    ],
  },
  {
    id: 'changes',
    heading: '7. Changes to This Policy',
    body: [
      'We may update this Privacy Policy periodically to reflect changes in our practices. Material changes will be communicated via a notice on our website or through email.',
    ],
  },
];

const contact = {
  heading: 'Contact Information',
  body: (
    <>
      For questions regarding this policy or to exercise your privacy rights, please contact us at <a href="mailto:hello@ainasuite.com">hello@ainasuite.com</a>.
    </>
  ),
};

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="May 12, 2026"
      intro={
        <>
          Welcome to Aina Suite (<a href="https://ainasuite.com/">https://ainasuite.com/</a>). We are committed to protecting your privacy and ensuring a secure experience while using our website, applications, and services (the "Service"). Aina Suite is operated by Moments View, located in Malaysia.
        </>
      }
      sections={sections}
      contact={contact}
    />
  );
}
